/**
 * PostDetailHeaderActions 컴포넌트
 * @description 글 상세 헤더의 오른쪽 — (언어 전환) · 공유. 언어 전환은 이 글을 읽을 수 있는
 *   **다른** 언어마다 하나씩 서고, 번역이 없는 글이면 서지 않는다. 웹에 경로가 없는 언어는
 *   서버가 알려 와도 세우지 않는다.
 */
import { memo } from "react";

import { postDetailStyles } from "./PostDetail.styles";
import type { PostDetailHeaderActionsProps } from "./PostDetail.types";
import PostDetailLanguageLink from "./PostDetailLanguageLink";
import PostDetailShareButton from "./PostDetailShareButton";

import { linkableBlogLanguages, toBlogLanguage } from "@/shared/config";

const PostDetailHeaderActions = memo<PostDetailHeaderActionsProps>(
  ({ post, title }) => {
    const current = toBlogLanguage(post.language);
    const others = linkableBlogLanguages(post.availableLanguages).filter(
      (language) => language !== current,
    );
    return (
      <div className={postDetailStyles.headerActions}>
        {others.map((language) => (
          <PostDetailLanguageLink
            key={language}
            post={post}
            language={language}
          />
        ))}
        <PostDetailShareButton post={post} title={title} />
      </div>
    );
  },
);

PostDetailHeaderActions.displayName = "PostDetailHeaderActions";

export default PostDetailHeaderActions;
